import EducationSectorCodebookContainer from '@src/components/codebook/EducationSectorCodebookContainer';
import React from 'react';

const AdminEducationSectorCodebookPage = () => <EducationSectorCodebookContainer />;

export default AdminEducationSectorCodebookPage;
